(function () {
  var badge = document.querySelector('[data-se-fitbadge]');
  if (!badge) return;
  var v = null; try { v = JSON.parse(localStorage.getItem('se_vehicle') || 'null'); } catch (e) {}
  if (!v || !v.vehicle) return;
  var isFlex = badge.dataset.kit === 'FLEX';
  if (!(isFlex || v.kit === badge.dataset.handle)) return;
  badge.querySelector('[data-fit-text]').textContent = 'Fits your ' + v.vehicle;
  badge.hidden = false;
  function ensure() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (f.closest('.quick-add, product-card, .product-card')) return;
      var i = f.querySelector('input[name="properties[Vehicle]"]');
      if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[Vehicle]'; f.appendChild(i); }
      i.value = v.vehicle;
    });
  }
  ensure();
  document.addEventListener('click', function (e) {
    if (e.target.closest('[id^="BuyButtons-ProductSubmitButton"], [ref="stickyBar"] button, button[name="add"], shopify-accelerated-checkout, .shopify-payment-button')) ensure();
  }, true);
  document.addEventListener('submit', ensure, true);
  document.addEventListener('change', function () { setTimeout(ensure, 600); });
})();
